import { render, staticRenderFns } from "./topTime.vue?vue&type=template&id=3cffabbe&scoped=true"
import script from "./topTime.vue?vue&type=script&lang=js"
export * from "./topTime.vue?vue&type=script&lang=js"
import style0 from "./topTime.vue?vue&type=style&index=0&id=3cffabbe&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cffabbe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/actions-runner/_work/treasurenet-tnservices-servicesplatform-fe/treasurenet-tnservices-servicesplatform-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3cffabbe')) {
      api.createRecord('3cffabbe', component.options)
    } else {
      api.reload('3cffabbe', component.options)
    }
    module.hot.accept("./topTime.vue?vue&type=template&id=3cffabbe&scoped=true", function () {
      api.rerender('3cffabbe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/stake/boosting/topTime.vue"
export default component.exports